module.exports = "/_next/static/images/141e6f17ac355e478f65a214360f9c0e-virtual-card-icon.svg.webp";